export default __webpack_public_path__ + "static/form-button-feedback-dont-ba883a8077a86ae2df2af9e6eec5f745f0d3b5ed9a687fbe8ad056de15be2962.png";